/**
 * Which revisions in a version group can be compared against each other, and
 * with which tool. Pure so the version-history modal's gating is testable
 * without mounting it.
 *
 * Two rules, because the pipelines differ: an IFC must already be parsed
 * (`IFC_PROCESSED`) for a diff to have anything to read, whereas the Drawings
 * tool generates DWG geometry on demand when the pair opens — so any two DWG
 * revisions qualify once the tool is reachable.
 */

import { isIfcFile } from "@/domains/documents/constants/fileTypes";
import { isDwgParentDoc } from "@/domains/documents/hooks/useDrawingViewer";

const IFC_PROCESSED = "IFC_PROCESSED";

export type CompareKind = "ifc" | "dwg";

/** The minimum a revision row must expose to be classified. */
export interface ComparableVersion {
  id: number;
  filename: string;
  state?: string | null;
}

/**
 * Classified per ROW, never on the group's anchor filename: a version group is
 * not extension-locked (a .pdf revision can legitimately follow a .dwg), so the
 * anchor's extension would both hide the action on a genuine revision and offer
 * it on one with nothing to diff.
 */
export function comparableKind(
  v: ComparableVersion,
  opts: { drawingsEnabled: boolean }
): CompareKind | null {
  if (isIfcFile(v.filename)) return v.state === IFC_PROCESSED ? "ifc" : null;
  if (isDwgParentDoc(v)) return opts.drawingsEnabled ? "dwg" : null;
  return null;
}
